/* tslint:disable */
/* eslint-disable */
/**
 * Committee Management API
 * The Law Society Committee Management Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AgendaFileRequest } from '../models';
import { BooleanResponse } from '../models';
import { CommitteeFileRequest } from '../models';
import { FileIEnumerableResponse } from '../models';
import { FileResponse } from '../models';
import { PersonalFile } from '../models';
import { PersonalFileResponse } from '../models';
import { StreamContent } from '../models';
/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a Committee File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete: async (yearId: number, committeeId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete.');
            }
            const localVarPath = `/api/v1/File/DeleteCommitteeFile/{yearId}/{committeeId}/{fileId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Delete a Meeting File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete: async (yearId: number, committeeId: number, meetingId: number, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete.');
            }
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete.');
            }
            const localVarPath = `/api/v1/File/DeleteMeetingFile/{yearId}/{committeeId}/{meetingId}/{fileId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Delete a Personal File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeletePersonalFileFileIdDelete: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileDeletePersonalFileFileIdDelete.');
            }
            const localVarPath = `/api/v1/File/DeletePersonalFile/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns file a as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDownloadStreamFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileDownloadStreamFileIdGet.');
            }
            const localVarPath = `/api/v1/File/Download-stream/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee files by yearId, committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetCommitteeFilesYearIdCommitteeIdGet: async (yearId: number, committeeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1FileGetCommitteeFilesYearIdCommitteeIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1FileGetCommitteeFilesYearIdCommitteeIdGet.');
            }
            const localVarPath = `/api/v1/File/GetCommitteeFiles/{yearId}/{committeeId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA All | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetFileCmaFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileGetFileCmaFileIdGet.');
            }
            const localVarPath = `/api/v1/File/GetFileCma/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetFileFileIdGet: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling apiV1FileGetFileFileIdGet.');
            }
            const localVarPath = `/api/v1/File/GetFile/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet: async (yearId: number, committeeId: number, meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'yearId' is not null or undefined
            if (yearId === null || yearId === undefined) {
                throw new RequiredError('yearId','Required parameter yearId was null or undefined when calling apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'committeeId' is not null or undefined
            if (committeeId === null || committeeId === undefined) {
                throw new RequiredError('committeeId','Required parameter committeeId was null or undefined when calling apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet.');
            }
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet.');
            }
            const localVarPath = `/api/v1/File/GetMeetingFiles/{yearId}/{committeeId}/{meetingId}`
                .replace(`{${"yearId"}}`, encodeURIComponent(String(yearId)))
                .replace(`{${"committeeId"}}`, encodeURIComponent(String(committeeId)))
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetPersonalFilesMeetingIdGet: async (meetingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            if (meetingId === null || meetingId === undefined) {
                throw new RequiredError('meetingId','Required parameter meetingId was null or undefined when calling apiV1FileGetPersonalFilesMeetingIdGet.');
            }
            const localVarPath = `/api/v1/File/GetPersonalFiles/{meetingId}`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveAgendaFilePost: async (body?: AgendaFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/File/SaveAgendaFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda Supporting File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveAgendaSupportingFilePost: async (body?: AgendaFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/File/SaveAgendaSupportingFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Committee File
         * @param {CommitteeFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveCommitteeFilePost: async (body?: CommitteeFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/File/SaveCommitteeFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {PersonalFile} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSavePersonalFilePost: async (body?: PersonalFile, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/File/SavePersonalFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a Committee File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId: number, committeeId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId, committeeId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Delete a Meeting File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId: number, committeeId: number, meetingId: number, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId, committeeId, meetingId, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Delete a Personal File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileDeletePersonalFileFileIdDelete(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileDeletePersonalFileFileIdDelete(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns file a as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileDownloadStreamFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamContent>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileDownloadStreamFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee files by yearId, committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileIEnumerableResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId, committeeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA All | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileGetFileCmaFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileGetFileCmaFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileGetFileFileIdGet(fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileGetFileFileIdGet(fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileIEnumerableResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileGetPersonalFilesMeetingIdGet(meetingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileGetPersonalFilesMeetingIdGet(meetingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileSaveAgendaFilePost(body?: AgendaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileSaveAgendaFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda Supporting File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileSaveAgendaSupportingFilePost(body?: AgendaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileSaveAgendaSupportingFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMA High Admin | Save Committee File
         * @param {CommitteeFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileSaveCommitteeFilePost(body?: CommitteeFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileSaveCommitteeFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {PersonalFile} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1FileSavePersonalFilePost(body?: PersonalFile, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalFileResponse>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).apiV1FileSavePersonalFilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary CMA High Admin | Delete a Committee File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId: number, committeeId: number, fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileApiFp(configuration).apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId, committeeId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Delete a Meeting File
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId: number, committeeId: number, meetingId: number, fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileApiFp(configuration).apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId, committeeId, meetingId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Delete a Personal File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDeletePersonalFileFileIdDelete(fileId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileApiFp(configuration).apiV1FileDeletePersonalFileFileIdDelete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns file a as stream
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileDownloadStreamFileIdGet(fileId: number, options?: any): AxiosPromise<StreamContent> {
            return FileApiFp(configuration).apiV1FileDownloadStreamFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee files by yearId, committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any): AxiosPromise<FileIEnumerableResponse> {
            return FileApiFp(configuration).apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA All | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetFileCmaFileIdGet(fileId: number, options?: any): AxiosPromise<FileResponse> {
            return FileApiFp(configuration).apiV1FileGetFileCmaFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Returns a File
         * @param {number} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetFileFileIdGet(fileId: number, options?: any): AxiosPromise<FileResponse> {
            return FileApiFp(configuration).apiV1FileGetFileFileIdGet(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
         * @param {number} yearId 
         * @param {number} committeeId 
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any): AxiosPromise<FileIEnumerableResponse> {
            return FileApiFp(configuration).apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {number} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileGetPersonalFilesMeetingIdGet(meetingId: number, options?: any): AxiosPromise<BooleanResponse> {
            return FileApiFp(configuration).apiV1FileGetPersonalFilesMeetingIdGet(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveAgendaFilePost(body?: AgendaFileRequest, options?: any): AxiosPromise<FileResponse> {
            return FileApiFp(configuration).apiV1FileSaveAgendaFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save Agenda Supporting File
         * @param {AgendaFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveAgendaSupportingFilePost(body?: AgendaFileRequest, options?: any): AxiosPromise<FileResponse> {
            return FileApiFp(configuration).apiV1FileSaveAgendaSupportingFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMA High Admin | Save Committee File
         * @param {CommitteeFileRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSaveCommitteeFilePost(body?: CommitteeFileRequest, options?: any): AxiosPromise<FileResponse> {
            return FileApiFp(configuration).apiV1FileSaveCommitteeFilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CMP | Save File
         * @param {PersonalFile} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1FileSavePersonalFilePost(body?: PersonalFile, options?: any): AxiosPromise<PersonalFileResponse> {
            return FileApiFp(configuration).apiV1FileSavePersonalFilePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @summary CMA High Admin | Delete a Committee File
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId: number, committeeId: number, fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileDeleteCommitteeFileYearIdCommitteeIdFileIdDelete(yearId, committeeId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Delete a Meeting File
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} meetingId 
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId: number, committeeId: number, meetingId: number, fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileDeleteMeetingFileYearIdCommitteeIdMeetingIdFileIdDelete(yearId, committeeId, meetingId, fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Delete a Personal File
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileDeletePersonalFileFileIdDelete(fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileDeletePersonalFileFileIdDelete(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns file a as stream
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileDownloadStreamFileIdGet(fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileDownloadStreamFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly | Returns Committee files by yearId, committeeId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId: number, committeeId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileGetCommitteeFilesYearIdCommitteeIdGet(yearId, committeeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA All | Returns a File
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileGetFileCmaFileIdGet(fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileGetFileCmaFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Returns a File
     * @param {number} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileGetFileFileIdGet(fileId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileGetFileFileIdGet(fileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin ReadOnly | Returns Committee Meetings by yearId and committeeId
     * @param {number} yearId 
     * @param {number} committeeId 
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId: number, committeeId: number, meetingId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileGetMeetingFilesYearIdCommitteeIdMeetingIdGet(yearId, committeeId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save File
     * @param {number} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileGetPersonalFilesMeetingIdGet(meetingId: number, options?: any) {
        return FileApiFp(this.configuration).apiV1FileGetPersonalFilesMeetingIdGet(meetingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save Agenda File
     * @param {AgendaFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileSaveAgendaFilePost(body?: AgendaFileRequest, options?: any) {
        return FileApiFp(this.configuration).apiV1FileSaveAgendaFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save Agenda Supporting File
     * @param {AgendaFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileSaveAgendaSupportingFilePost(body?: AgendaFileRequest, options?: any) {
        return FileApiFp(this.configuration).apiV1FileSaveAgendaSupportingFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMA High Admin | Save Committee File
     * @param {CommitteeFileRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileSaveCommitteeFilePost(body?: CommitteeFileRequest, options?: any) {
        return FileApiFp(this.configuration).apiV1FileSaveCommitteeFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary CMP | Save File
     * @param {PersonalFile} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public apiV1FileSavePersonalFilePost(body?: PersonalFile, options?: any) {
        return FileApiFp(this.configuration).apiV1FileSavePersonalFilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
